import { Box, Group, Skeleton } from '@mantine/core';

/**
 * Most recipes list ~10-14 ingredients; a shorter placeholder makes the
 * column visibly grow when the real list lands.
 */
export const INGREDIENT_SKELETON_ROWS = 12;

/**
 * Placeholder rows for the recipe ingredients card (render inside its Paper
 * > Stack gap={0}): ingredient text on the left, the row's action icon on the
 * right, divided like the real list. Shared by the details page's loading
 * skeleton and the list-item preview so the two match.
 */
export const IngredientRowsSkeleton = () => (
  <>
    {Array.from({ length: INGREDIENT_SKELETON_ROWS }).map((_, i) => (
      <Box
        key={i}
        py="xs"
        style={{
          borderBottom:
            i < INGREDIENT_SKELETON_ROWS - 1 ? '1px solid var(--mantine-color-gray-2)' : 'none',
        }}
      >
        {/* As tall as a real row's content: its menu button (ActionIcon
            size="md", 28px) out-heights the single-line text, so real
            single-line rows are 45px with the padding and divider */}
        <Group justify="space-between" mih={28}>
          <Skeleton height={14} width={`${40 + (i % 3) * 15}%`} />
          <Skeleton height={20} width={20} radius="sm" />
        </Group>
      </Box>
    ))}
  </>
);
